import React from 'react';
import PropTypes from 'prop-types';

const BasicBlock = (props) => {
  const {
    breakpoints, url, image, image_alt, image_srcset,
    heading, content, display_date, label, label_colour
  } = props;

  return (
    <div className="carousel-block basic-block">
      <a href={url} className="not-a">
        <div className="w-100 flex flex-column justify-between h-100">
          <div>
            {/* Image */}
            {image && (
              <img
                src={image}
                className="w-100"
                alt={image_alt}
                srcSet={image_srcset}
                sizes={`${breakpoints.desktop} 25vw, 250px`}
              />
            )}

            {/* Heading */}
            <h3 className="h5">{heading}</h3>

            {/* Main content */}
            <div className="p-small">
              {content}
            </div>
          </div>

          <div>
            {/* Display date */}
            {(display_date || label) && (
              <div className="HomeSection-meta mt2">
                <time className="HomeSection-time">{display_date}</time>
                {label && (
                  <div className={`HomeSection-label HomeSection-label--${label_colour.toLowerCase()} xsmall`}>
                    {label}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </a>
    </div>
  );
};

BasicBlock.propTypes = {
  breakpoints: PropTypes.shape({
    desktop: PropTypes.string.isRequired
  }).isRequired,
  url: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  content: PropTypes.string,
  display_date: PropTypes.string,
  label: PropTypes.string,
  label_colour: PropTypes.string,
  image: PropTypes.string,
  image_alt: PropTypes.string,
  image_srcset: PropTypes.string
};

BasicBlock.defaultProps = {
  label_colour: 'blue',
  image_alt: null
};

const BasicBlockSection = ({ content, heading, colour, breakpoints }) => {
  const { items } = content;

  if (!items) return null;

  while (items.length < 4) {
    items.push(false);
  }

  return (
    <div className="db mb4 w-100 carousel-wrapper">
      {heading && (
        <h2
          dangerouslySetInnerHTML={{ __html: heading }}
          className={`col-1 color-${colour} h2 mb3 mt0`}
        />
      )}

      <div className="carousel-block-wrapper pb4">
        {content.items.map((item) => {
          // still render the space but hidden to keep block widths consistent
          if (!item) {
            return <div className="carousel-block basic-block hidden" />;
          }

          return <BasicBlock {...item.content} breakpoints={breakpoints} />;
        })}

        {/* white space at the end of the carousel */}
        <div className="dn-l" style={{ minWidth: '18px' }} />
      </div>
    </div>
  );
};

BasicBlockSection.propTypes = {
  heading: PropTypes.string,
  colour: PropTypes.string,
  content: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        content: PropTypes.object.isRequired
      }).isRequired
    ).isRequired
  }).isRequired,
  breakpoints: PropTypes.object.isRequired
};

BasicBlockSection.defaultProps = {
  colour: 'blue'
};

export default BasicBlockSection;
